import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function CellarPage() {
  const { search } = useLocation();
  return <Navigate to={`/${search}`} replace />;
}
